export default __webpack_public_path__ + "static/media/262.644149b8.jpg";